import {observer} from "mobx-react";
import PageAncestor from "../../../core/common/page/pageAncestor";
import {MODULE, PageProps} from "../../../core/metamodel/metaConstant";
import {loc} from "../../../core/common/config/locales";
import {MATERIAL_USAGE_GROUPS_LIST} from "../../gridsContants";
import gridService from "../../../core/grid/gridService";
import GridCompConnected from "../../../core/grid/component/gridCompConnected";
import mdEntityService from "../../../core/metamodel/mdEntityService";
import React from "react";


@observer
export default class MaterialUsageGroupsList extends PageAncestor<PageProps, undefined> {

  static module = MODULE.sbtool;
  static title = loc.i18n`Usage groups`;
  static icon = 'list';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("MaterialUsageGroupsList#fetchData(%s)", MATERIAL_USAGE_GROUPS_LIST);

    return gridService.fetchGrids(MATERIAL_USAGE_GROUPS_LIST)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(MATERIAL_USAGE_GROUPS_LIST);
      });
  }

  render() {
    let { params, query } = this.props;


    return (
      <GridCompConnected grid={gridService.getOrCreateGrid(MATERIAL_USAGE_GROUPS_LIST)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query} />
  );
  }


}



// WEBPACK FOOTER //
// ./src/sbtool/page/material/materialUsageGroupsList.tsx